import {
  EnvironmentKey,
  getEnvironmentConfig,
  getEnvironmentDisplayName,
  isProduction,
} from '@choco-admin/utils';
import { Button } from '@heroui/react';
import React, { useState } from 'react';

import { EnvironmentModal } from './EnvironmentModal';

interface EnvironmentSelectorProps {
  currentEnvironment: EnvironmentKey;
  onEnvironmentChange: (env: EnvironmentKey) => void;
  disabled?: boolean;
}

export const EnvironmentSelector: React.FC<EnvironmentSelectorProps> = ({
  currentEnvironment,
  onEnvironmentChange,
  disabled = false,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Don't render in production
  if (isProduction()) {
    return null;
  }

  const handleEnvironmentSelect = (environment: EnvironmentKey) => {
    setIsModalOpen(false);
    onEnvironmentChange(environment);
  };

  const displayName = getEnvironmentDisplayName(currentEnvironment);

  return (
    <>
      <Button
        isIconOnly
        className="fixed bottom-12 left-10 z-[999] w-12 h-12 rounded-full border-2 border-default-200 bg-background shadow-lg hover:-translate-y-0.5 hover:shadow-xl hover:border-primary transition-all duration-200 focus:border-primary focus:ring-2 focus:ring-primary/25"
        onClick={() => setIsModalOpen(true)}
        disabled={disabled}
        title={`Current environment: ${displayName}`}
        aria-label={`Current environment: ${displayName}. Click to change environment.`}
      >
        <span className="text-2xl leading-none">
          {getEnvironmentConfig(currentEnvironment).emoji}
        </span>
      </Button>

      {isModalOpen && (
        <EnvironmentModal
          currentEnvironment={currentEnvironment}
          onEnvironmentSelect={handleEnvironmentSelect}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
};
